import Header from './head/index'
import React, { createContext, useEffect, useState,lazy ,Suspense} from "react"
import { TempleteType } from '../common/enum'
// import TempleteOne from './TempleteOne/index'
// import TempleteTwo from './TempleteTwo/index'
// import TempleteThree from './TempleteThree/index'
// import TempleteFour from './TempleteFour/index'
// import TempleteFive from './TempleteFive/index'
// import TempleteSix from './TempleteSix/index'
// import TempleteSeven from './TempleteSeven/index'
// import TempleteEight from './TempleteEight/index'
// import TempleteNine from './TempleteNine/index'
// import TemplateTen from './TemplateTen/index'
// import TemplateEleven from './TemplateEleven/index'
// import TemplateTwelve from './TemplateTwelve/index'
// import TemplateThirteen from './TemplateThirteen/index'
// import TemplateFourteen from './TemplateFourteen/index'
// import TemplateFifteen from './TemplateFifteen/index'
// import TemplateSixteen from './TemplateSixteen/index'
import axios from 'axios'
import StoreContext from './store'
import { useTranslation, } from 'react-i18next'
const App = () => {
  let windowData: any = window
  console.log("%c Line:14 🍓 window", "color:#ffdd4d", window);
  const [store, setStore] = useState({});
  const { t, i18n } = useTranslation();
  const [TemplateComponent, setTemplateComponent] = useState<React.LazyExoticComponent<any> | null>(null);
  useEffect(() => {
    setStore(windowData.config)
    i18n.changeLanguage(windowData.config.language)
  }, [])

  useEffect(() => {
    const stores: any = store;
    const templeteId = stores?.templeteId;

    switch (Number(templeteId)) {
      case TempleteType.templeteOne:
        setTemplateComponent(lazy(() => import('./TempleteOne/index')));
        break;
      case TempleteType.templeteTwo:
        setTemplateComponent(lazy(() => import('./TempleteTwo/index')));
        break;
      case TempleteType.templeteThree:
        setTemplateComponent(lazy(() => import('./TempleteThree/index')));
        break;
      case TempleteType.templeteFour:
        setTemplateComponent(lazy(() => import('./TempleteFour/index')));
        break;
      case TempleteType.templeteFive:
        setTemplateComponent(lazy(() => import('./TempleteFive/index')));
        break;
      case TempleteType.templeteSix:
        setTemplateComponent(lazy(() => import('./TempleteSix/index')));
        break;
      case TempleteType.templeteSeven:
        setTemplateComponent(lazy(() => import('./TempleteSeven/index')));
        break;
      case TempleteType.templeteEight:
        setTemplateComponent(lazy(() => import('./TempleteEight/index')));
        break;
      case TempleteType.templeteNine:
        setTemplateComponent(lazy(() => import('./TempleteNine/index')));
        break;
      case TempleteType.templeteTen:
        setTemplateComponent(lazy(() => import('./TemplateTen/index')));
        break;
      case TempleteType.templeteEleven:
        setTemplateComponent(lazy(() => import('./TemplateEleven/index')));
        break;
      case TempleteType.templeteTwelve:
        setTemplateComponent(lazy(() => import('./TemplateTwelve/index')));
        break;
      case TempleteType.templeteThirteen:
        setTemplateComponent(lazy(() => import('./TemplateThirteen/index')));
        break;
      case TempleteType.templeteFourteen:
        setTemplateComponent(lazy(() => import('./TemplateFourteen/index')));
        break;
      case TempleteType.templeteFifteen:
        setTemplateComponent(lazy(() => import('./TemplateFifteen/index')));
        break;
      case TempleteType.templeteSixteen:
        setTemplateComponent(lazy(() => import('./TemplateSixteen/index')));
        break;
      default:
        setTemplateComponent(null); 
    }
  }, [store]);
  return (
    <StoreContext.Provider value={store} >
      <Header />
      <Suspense fallback={<div>Loading...</div>}>
        {TemplateComponent ? <TemplateComponent /> : <div>No template found</div>}
      </Suspense>
    </StoreContext.Provider >

  );
}

export default App;
